import React from 'react';
import styled from 'styled-components';
import type {MessageActivity} from '../types/activityEvent';

type DeliveryStatus = NonNullable<MessageActivity['delivery_status']>;

// Tailwind default palette (blue/yellow/red 100/800) — no DS token equivalent,
// so the rendered hex is preserved here.
const STATUS_COLORS: Record<DeliveryStatus, {bg: string; text: string}> = {
	queued: {bg: '#dbeafe', text: '#1e40af'},
	sending: {bg: '#fef9c3', text: '#854d0e'},
	sent: {bg: 'transparent', text: 'inherit'},
	failed: {bg: '#fee2e2', text: '#991b1b'},
};

interface Props {
	delivery_status: MessageActivity['delivery_status'];
	retry_count: number;
}

const Badge = styled.span<{$status: DeliveryStatus}>`
	display: inline-flex;
	align-items: center;
	border-radius: 9999px;
	padding: 2px 10px;
	${p => p.theme.sys.font?.detail?.['1']}
	font-weight: 500;
	background: ${p => STATUS_COLORS[p.$status].bg};
	color: ${p => STATUS_COLORS[p.$status].text};
`;

export function DeliveryStatusBadge({delivery_status, retry_count}: Props) {
	if (delivery_status === null || delivery_status === 'sent') return null;

	let label: string;
	if (delivery_status === 'queued') {
		label = 'Queued';
	} else if (delivery_status === 'sending') {
		label = 'Sending…';
	} else {
		label = retry_count >= 3 ? 'Failed — retries exhausted' : 'Failed';
	}

	return <Badge $status={delivery_status}>{label}</Badge>;
}
